import React from "react";
import UserPanel from "../../components/User/UserPanel";
// import List from "../../components/List/List";
import PeopleCardsList from "../../components/PeopleCardsList/PeopleCardsList";
import Section from "../../components/UI/Section/Section";
import { Alert, Form, Button } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";

import { getDatabase, ref, onValue } from "firebase/database";

import { useAuth } from "../../contexts/AuthContext";

const debug = false;

const db = getDatabase();

const PeoplePage = () => {
  const idRef = useRef();
  const nameRef = useRef();

  const { scores } = useAuth();
  const [isFiltered, setIsFiltered] = useState(false);

  const [users, setUsers] = useState([]);
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const colTitles = ["id", "name", "time"];

  var usersRef = ref(db, "users");
  onValue(usersRef, (snapshot) => {
    const data = snapshot.val();
    if (JSON.stringify(data) !== JSON.stringify(users)) {
      setUsers(data);
    }
  });

  useEffect(() => {
    //convert obj tree into array
    setItems([
      // colTitles,
      ...Object.keys(users).map((id) => ({
        id: id,
        name: users[id].name,
        image: users[id].photoURL,
        link: `/users/${id}`,
        score: isNaN(scores[id]) ? 0 : scores[id],
      })),
    ]);
  }, [users, scores]);

  useEffect(() => {
    setFilteredItems(items);
  }, [items]);

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    const filter = {
      // id: idRef.current.value,
      name: nameRef.current.value,
    };

    setFilteredItems(
      items.filter(function (item, i) {
        return item["name"].toLowerCase().includes(filter.name.toLowerCase());
        // && item["id"].includes(filter.id)
      })
    );
    setIsFiltered(nameRef.current.value.length);

    debug && console.log("PeoplePage.js filtered:", filteredItems);
  };

  return (
    <>
      <UserPanel />
      <Section>
        <h2 className="Heading">Люди</h2>

        <Form onSubmit={handleFilterSubmit} className="Form">
          <Form.Group id="terms" className="">
            <Form.Control
              type="text"
              ref={nameRef}
              className={`contracts-list-col`}
              placeholder="Поиск"
              onChange={handleFilterSubmit}
            />
          </Form.Group>
        </Form>
      </Section>
      <Section>
        <h2 className="Heading">{isFiltered ? "Поиск: " +  nameRef.current.value: "Рейтинг"}</h2>
        <PeopleCardsList
          items={filteredItems.sort((a, b) => b.score - a.score)}
          isFiltered={isFiltered}
        />
      </Section>
    </>
  );
};
export default PeoplePage;
